import { umsgKpiPerformance } from 'bl/umsgs.bl';
import H from 'constants/httpMethod.const';
import MS from 'constants/time/ms.const';
import createFromDtoToStylistsPerfInfo from 'dto/kpi/createFromDtoToStylistsPerfInfo.dto';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beKpiPersonalPerformance'); // eslint-disable-line no-unused-vars

// SEE: https://github.com/getslick/api.core/blob/staging/docs/KPI_performance.md

const MISSING = 'Missing one or more of the required parameters';

const reconfigure = (config) => (options, extra) => {
  const bgn = fromAnyDateToIso(extra?.bgn) || null;
  const end = fromAnyDateToIso(extra?.end) || null;

  const params = { bgn, end };

  if (!bgn || !end) {
    L.warn('reconfigure()', options?.name, MISSING, params, 'for', { config, options, extra });
  }

  return {
    ...options,
    ...config,
    params,
    fromDto: createFromDtoToStylistsPerfInfo({ bgn, end }),
    umsg: umsgKpiPerformance,
    timeout: 27.5 * MS.second,
  };
};

export const ibeKpiPersonalPerformanceRead = actionEndpointBe(
  'ibeKpiPersonalPerformanceRead',
  H.get,
  'metrics/kpi/personal/performance/:salonId/:bgn/:end/',
  reconfigure({ inert: true }),
);

export const abeKpiPersonalPerformanceRead = actionEndpointBe(
  'abeKpiPersonalPerformanceRead',
  H.get,
  'metrics/kpi/personal/performance/:salonId/:bgn/:end/',
  reconfigure({ inert: false }),
);
